import {json, JsonMappers} from '../core/data-source/json.mapper';

export class UISettingsRecord {
    @json({
        jsonName: 'LANG',
        value: 'EN',
        mapper: {
            from: (value: string) => value.toLowerCase()
        }
    })
    language: string;

    @json() title: string;

    carrotQuestEnabled: boolean;

    @json({
        jsonName: 'rc.site_key'
    })
    rcSiteKey: string;

    @json()
    account: string;

    @json({
        jsonName: 'ga.trackingId'
    })
    gaTrackingId: string;

    @json({
        jsonName: 'CURRENT_EXTERNAL_SERVER_URL'
    })
    currentExternalServerUrl: string;

    @json({
        jsonName: 'evo_platform_url'
    })
    evoPlatformUrl: string;

    @json({
        jsonName: 'enforce_evo_migration',
        mapper: JsonMappers.Boolean,
        value: false
    })
    enforceEvoMigration: boolean;

    @json({
        jsonName: 'evo_linked',
        mapper: JsonMappers.Boolean,
        value: true
    })
    evoLinked: boolean;
}
